
import { useEffect, useMemo, useState } from "react";
import "./App.css";
import 'react-toastify/dist/ReactToastify.css';

import { ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import { CacheProvider } from "@emotion/react";
import themeRTL from "./assets/theme/theme-rtl";

import { mainRoutes, navRoutes } from "./routes";
import brand from "./assets/images/logo-ct.png";
import { Navigate, Route, Routes, useLocation } from "react-router-dom";
import Sidenav from "./components/sidenav";
import createCache, { EmotionCache } from "@emotion/cache";
import rtlPlugin from "stylis-plugin-rtl";
import Configurator from "./components/configurator";
import SoftBox from "./components/common/softBox";
import { Icon } from "@mui/material";

import { useSoftUIController, setMiniSidenav, setOpenConfigurator } from "./context";
import theme from "./assets/theme";
import { ToastContainer } from "react-toastify";

import PrivateRoute from "./PrivateRoute";
import SignIn from "./pages/authentication/sign-in";
import { Dashboard } from "@mui/icons-material";
import { SoftUIController } from "./types/common";
import { Dispatch } from "@reduxjs/toolkit";
import settingIcon from "./assets/images/settings.png";

function App() {
  const [rtlCache, setRtlCache] = useState<EmotionCache | undefined>(undefined);

  const { pathname } = useLocation();

  useMemo(() => {
    const cacheRtl = createCache({
      key: "rtl",
      stylisPlugins: [rtlPlugin],
    });
    setRtlCache(cacheRtl);
  }, []);

  const [controller, dispatch] = useSoftUIController() as [SoftUIController, Dispatch<any>];
  const { miniSidenav, direction, layout, openConfigurator, sidenavColor } = controller;
  // console.log(direction,'directiondirection');

  const [onMouseEnter, setOnMouseEnter] = useState(false);

  const handleOnMouseEnter = () => {
    if (miniSidenav && !onMouseEnter) {
      setMiniSidenav(dispatch, false);
      setOnMouseEnter(true);
    }
  };

  // Close sidenav when mouse leaves mini sidenav
  const handleOnMouseLeave = () => {
    if (onMouseEnter) {
      setMiniSidenav(dispatch, true);
      setOnMouseEnter(false);
    }
  };

  const handleConfiguratorOpen = () => setOpenConfigurator(dispatch, !openConfigurator);



  // Setting the dir attribute for the body element
  useEffect(() => {
    document.body.setAttribute("dir", direction);
  }, [direction]);

  useEffect(() => {
    document.documentElement.scrollTop = 0;
    document.scrollingElement && (document.scrollingElement.scrollTop = 0);
  }, [pathname]);



  const getRoutes = (allRoutes: any) =>

    allRoutes.map((route: any) => {
      if (route.collapse) {
        return getRoutes(route.collapse);
      }

      if (route.route) {


        return <Route path={route.route} element={<PrivateRoute element={route.component} />} key={route.key} />;
      }

      return null;
    });

  const configsButton = (


    <SoftBox
      display="flex"
      justifyContent="center"
      alignItems="center"
      width="3.5rem"
      height="3.5rem"
      bgColor="white"
      shadow="sm"
      borderRadius="50%"
      position="fixed"
      right="2rem"
      bottom="2rem"
      zIndex={99}
      color="dark"
      sx={{ cursor: "pointer" }}
      onClick={handleConfiguratorOpen}
    >


      <Icon color="inherit">
        <img src={settingIcon} alt="icon"/>
      </Icon>
    </SoftBox>
  );


  useEffect(() => {
    console.log("direction :: ", direction);
  }, [])

  return (
    // <div>
    //   {/* @ts-ignore */}
    //   <ToastContainer />
    //   {/* @ts-ignore */}

    //   <CacheProvider value={rtlCache}>
    //     <ThemeProvider theme={direction === "rtl" ? themeRTL : theme}>

    //         <CssBaseline />
    //         {layout === "dashboard" && (
    //           <>
    //             <Sidenav
    //               color={sidenavColor}
    //               brand={brand}
    //               brandName="Soft UI Dashboard"
    //               routes={routes}
    //               onMouseEnter={handleOnMouseEnter}
    //               onMouseLeave={handleOnMouseLeave}
    //             />
    //             <Configurator />
    //             {configsButton}
    //           </>
    //         )}
    //         {layout === "vr" && <Configurator />}
    //         <Routes>
    //           {getRoutes(routes)}
    //           <Route path="*" element={<Navigate to="/dashboard" />} />
    //           {/* @ts-ignore */}

    //           <Route path="/faq/edit/:id" element={<EditFaq />} />
    //           {/* @ts-ignore */}

    //           <Route path="faq/add" element={<AddFaq />} />
    //           {/* @ts-ignore */}

    //           <Route path="/room-type/edit/:id" element={<EditRoomType />} />
    //           <Route path="/room-type/add" element={<AddRoomType />} />
    //           <Route path="/room/add" element={<AddRoom />} />
    //           <Route path="/room/edit/:id" element={<EditRoom />} />

    //           <Route path="*" element={<Navigate to="/dashboard" />} />

    //         </Routes>

    //     </ThemeProvider>
    //   </CacheProvider>
    // </div>

    direction === "rtl" ? (
      <>
        <ToastContainer />

        <CacheProvider value={rtlCache!}>
          <ThemeProvider theme={themeRTL}>
            <CssBaseline />
            {layout === "dashboard" && (
              <>
                <Sidenav
                  color={sidenavColor}
                  brand={brand}
                  brandName="Ebreaze"
                  routes={Route}
                  onMouseEnter={handleOnMouseEnter}
                  onMouseLeave={handleOnMouseLeave}
                />
                <Configurator />
                {configsButton}
              </>
            )}
            {layout === "vr" && <Configurator />}
            <Routes>
              {getRoutes(navRoutes)}
              {mainRoutes.map((route) => (
                <>
                <Route key={route.key} path={route.route} element={<PrivateRoute element={route.component} />} />
                </>
              ))}
              <Route path="/authentication/sign-in" element={<SignIn />} />
            </Routes>

          </ThemeProvider>
        </CacheProvider>
      </>
    ) : (
      <>
        <ToastContainer />

        <ThemeProvider theme={theme}>
          <CssBaseline />
          {layout === "dashboard" && (
            <>
              <Sidenav
                color={sidenavColor}
                brand={brand}
                brandName="Ebreaze"
                routes={navRoutes}
                onMouseEnter={handleOnMouseEnter}
                onMouseLeave={handleOnMouseLeave}
              />
              <Configurator />
              {configsButton}
            </>
          )}
          {layout === "vr" && <Configurator />}
          <Routes>
            {getRoutes(navRoutes)}
            {mainRoutes.map((route) => (
              <Route key={route.key} path={route.route} element={<PrivateRoute element={route.component} />} />
            ))}
            <Route path="/authentication/sign-in" element={<SignIn />} />
            <Route path="*" element={<PrivateRoute element={<Dashboard />} />} />



            {/* <Route path="/" element={<Navigate to="/dashboard" />} /> */}
          </Routes>
        </ThemeProvider>
      </>
    ))
}

export default App;
